import { getBposNavBarData } from 'owa-bpos-store';
import type { ShellClientData } from '@suiteux/suiteux-shell';

export default function getShellClientData(): ShellClientData {
    try {
        return JSON.parse(getBposNavBarData().ClientData) as ShellClientData;
    } catch {
        return null;
    }
}
